<template>
<div class="address-list-dialog-box">
  <el-dialog title="选择门店地址" v-model="showModal" custom-class="address-list-dialog"  @close="closeModel">
    <div class="dialog-main" v-if="addressList.length !== 0">
      <div class="address-list-box">
        <div class="address-list-item" @click="selectAddress = address;" :class="{'active': address.peer_address_id === selectAddress.peer_address_id}"  v-for="(address,index) in addressList" :key="index">
          <div class="address-item-top">
            <div class="address-field-name">{{address.addressee}}</div>
            <div class="address-field-phone">{{address.mobile_phone}}</div>
            <div class="address-field-email">{{address.email}}</div>
            <div class="address-field-default" v-if="address.is_default">默认地址</div>
            <div class="address-handle">
              <span @click.stop="setDefaultAddress(address)" v-if="!address.is_default">设为默认</span>
              <span @click.stop="editAddress(address)">编辑</span>
            </div>
          </div>
          <div class="address-item-bottom">
            <div class="address-field-address">{{getAddress(pcds, address)}}</div>
          </div>
        </div>
      </div>
      <div class="dialog-footer-btns">
        <el-button @click="addAddress" size="large" class="dialog-footer-btn" style="color:#5e9be1;border-color:#5e9be1;">新增地址</el-button>
        <el-button @click="submitSelectAddress" :disabled="!selectAddress.addressee" type="primary" size="large"  class="dialog-footer-btn">确定</el-button>
      </div>
    </div>
    <div class="address-list-null" v-else>
      <div class="img-box">
        <img src="../../../assets/imgs/address/address_none.png" />
      </div>
      <div class="label">
        您还没有创建收货地址哦
      </div>
      <div class="new-address">
        <el-button @click="addAddress" type="primary" size="large" class="new-address-btn">新增地址</el-button>
      </div>
    </div>
  </el-dialog>

  <!-- 地址对话框 -->
  <address-add-or-edit-modal
    v-model="addressModel.visible"
    v-if="addressModel.visible"
    :address="addressModel.address"
    @on-success="addressAddOrEditSuccess"
  ></address-add-or-edit-modal>

</div>

</template>
<script>
import orderComfirmService from '../../../services/order-comfirm-service';
import addressUtils from '../../../libs/address-utils';
import pcdService from '../../../services/pcd-service';
import addressAddOrEditModal from './address-add-or-edit-modal';
import Http from '../../../libs/http';
import utils from '../../../libs/utils';

export default {
  name: 'address-list-model',
  components: {
    addressAddOrEditModal,
  },
  data() {
    return {
      showModal: this.value,
      addressList: [],
      selectAddress: {},
      pcds: {}, // 省市区数据
      addressModel: {
        visible: false,
        type: 'add',
        address: {},
      },
    };
  },
  props: {
    // 是否打开
    value: {
      type: Boolean,
      required: true,
      default: false,
    },
  },
  created() {
    pcdService.getPcd().then((pcds) => {
      this.pcds = pcds;
    }).catch((e) => {
      if (e) console.log(e);
    });
    this.getAddressList();
  },
  methods: {
    getAddress: addressUtils.getAddress,
    getAddressList() {
      orderComfirmService.peerAddressBriefQuery()
        .then((data) => {
          this.addressList = data.result;
        })
        .catch((e) => {
          if (e) console.log(e);
        });
    },
    closeModel() {
    },
    submitSelectAddress() {
      this.showModal = false;
      utils.msg.success('修改成功');
      this.$emit('select-address-success', this.selectAddress);
    },
    // 设置默认地址
    setDefaultAddress(address) {
      Http.post('/peer_address_set_default', {
        peer_address_id: address.peer_address_id,
      }).then(() => {
        this.addressList.forEach((ad) => { ad.is_default = 0; });
        address.is_default = 1;
        utils.msg.success('设置成功');
      }).catch((e) => {
        if (e) console.log(e);
      });
    },
    editAddress(address) {
      this.addressModel.visible = true;
      this.addressModel.type = 'edit';
      this.addressModel.address = address;
    },
    addAddress() {
      this.addressModel.visible = true;
      this.addressModel.type = 'add';
      this.addressModel.address = {};
    },
    addressAddOrEditSuccess({ address, type, isNotSaveAddressStoreroom }) {
      if (!isNotSaveAddressStoreroom) {
        // 需要保存到订单，则添加至list
        if (type === 'add') {
          this.addressList.unshift(address);
        } else {
          this.addressList.forEach((item) => {
            if (item.peer_address_id === address.peer_address_id) {
              Object.assign(item, address);
            }
          });
        }
      }
      // 当前直接返回到上一级去
      this.selectAddress = address;
      this.submitSelectAddress();
    },
  },
  watch: {
    value(newVal) {
      this.showModal = newVal;
    },
    showModal(newVal) {
      this.$emit('input', newVal);
      if (!newVal) {
        // 隐藏弹窗时把选中的地址清空
        this.selectAddress = {};
      }
    },
  },
};
</script>
<style lang="less" scoped>
.address-list-dialog-box{
  /deep/ .address-list-dialog{
    width: 640px;
    .el-dialog__header{
      padding: 20px;
      text-align: center;
      border-bottom: 1px solid #f0f0f0;
      .el-dialog__title{
        font-size: 16px;
        color: #333;
        font-weight: normal;
      }
    }
    .el-dialog__body{
      padding: 0;
    }
  }
}
.dialog-main{
  .address-list-box{
    padding: 20px 30px;
    min-height: 224px;
    max-height: 400px;
    overflow: auto;
    .address-list-item.active{
      background: url(../../../assets/imgs/recharge-gou.png) no-repeat top right;
      border-color: #5e9be1;
    }
    .address-list-item{
      border-radius: 4px;
      border: solid 1px #e9e9e9;
      background: #fff;
      margin-bottom: 20px;
      padding: 20px;
      padding-bottom: 15px;
      font-size: 14px;
      position: relative;
      cursor: pointer;
      &:hover{
        border-color: #5e9be1;
        .address-handle{
          display: block;
        }
      }
      &:last-child{
        margin-bottom: 0px;
      }
      .address-item-top{
        display: flex;
        margin-bottom: 9px;
        .address-field-name{
          color: #333;
          font-weight: 600;
          margin-right: 20px;
        }
        .address-field-phone{
          color: #777;
          margin-right: 10px;
        }
        .address-field-email{
          color: #777;
          margin-right: 20px;
        }
        .address-field-default{
          font-size: 11px;
          line-height: 14px;
          letter-spacing: 0px;
          padding: 0 3px;
          height: 14px;
          text-align: center;
          color: #fff;
          background-color: #cfcfcf;
	        border-radius: 2px;
        }
      }
      .address-item-bottom{
        padding-right: 46px;
        .address-field-address{
          line-height: 24px;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp:2;
          -webkit-box-orient: vertical;
        }
      }
      .address-handle{
        flex-grow: 1;
        text-align: right;
        display: none;
        span{
          color: #5e9be1;
          cursor: pointer;

        }
        span + span{
          margin-left: 5px;
        }
      }
    }
  }
}
.dialog-footer-btns{
  display: flex;
  justify-content: center;
  border-top: 1px solid #f0f0f0;
  padding: 10px;
  .dialog-footer-btn{
    width: 200px;
    font-size: 14px;
    height: 40px;
  }
  .dialog-footer-btn + .dialog-footer-btn{
    margin-left: 20px;
  }
}
.address-list-null{
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 80px 0 110px 0;
  .img-box{
    width: 140px;
    height: 103px;
    margin-bottom: 22px;

  }
  .label{
    font-size: 14px;
    color: #333;
    margin-bottom: 20px;
  }
  .new-address{
    .new-address-btn{
      border-radius: 20px;
      width: 200px;
      height: 40px;
      font-size: 14px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/ordering/modals/address-list-modal.vue